import { type ReactNode } from 'react';

import styles from './TruncatedText.module.css';

export type TruncatedTextProps = {
  children: ReactNode;
  title: string;
};

export const TruncatedText = ({
  children,
  title,
}: TruncatedTextProps): JSX.Element => (
  <span className={styles.text} title={title}>
    {children}
  </span>
);
